export const API_URL = "https://thesweetserver.onrender.com/"